const { createElement } = window.BAO.Utils

class BaoProductMedia extends window.BAO.Carousel.Element {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  renderTemplate () {
    const template = createElement('div', {
      class: 'prd-MediaZoom',
      'data-bao-product-media-external-el': 'wrapper',
    })
    template.insertAdjacentHTML(
      'afterbegin',
      `
      ${this.renderThumbnails()}

      ${this.renderImages()}

      <button type="button" class="prd-MediaZoom_Close">
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 14 14" width="14" height="14"><path d="M.693 1.4l11.749 11.749.707-.707L1.4.693z"></path><path d="M12.442.693L.693 12.442l.707.707L13.149 1.4z"></path></svg>
        <span class="util-ScreenReaderOnly">Close</span>
      </button>
    `,
    )

    Array.from(template.querySelectorAll('[data-thumbnail]')).forEach(
      thumbnail => {
        thumbnail.addEventListener('click', () => {
          template
            .querySelector(
              `[data-slide="${thumbnail.getAttribute('data-thumbnail')}"]`,
            )
            .scrollIntoView({ behavior: 'smooth' })
          template.querySelectorAll('[data-thumbnail]').forEach(
            tn => {
              tn.setAttribute('aria-current', false)
            },
          )
          thumbnail.setAttribute('aria-current', true)
        })
      },
    )

    return template
  }

  renderThumbnails () {
    const template = createElement('div', {
      class: 'prd-MediaZoom_Thumbnails',
    })

    template.appendChild(this.els.thumbnails.element.cloneNode(true))

    return template.outerHTML
  }

  renderImages () {
    const template = createElement('div', {
      class: 'prd-MediaZoom_Slides',
    })
    template.appendChild(this.els.slides.element.cloneNode(true))

    return template.outerHTML
  }

  static get requiredElements () {
    return super.requiredElements.concat(['slides', 'slide', 'dot', 'thumbnail', 'previous', 'next'])
  }

  setupListeners () {
    super.setupListeners()

    this.els.slide.elements.forEach(element => {
      this.listeners.add(element, 'click', this.onImageClick.bind(this))
    })

    this.els.thumbnail.elements.forEach(element => {
      this.listeners.add(element, 'click', this.trackThumbnailClick.bind(this))
    })
  }

  onImageClick (event) {
    const image = event.target.closest(this.els.slide.selector)

    if (!image) return

    let slideIndex = image.dataset.index

    if (slideIndex === undefined) {
      slideIndex = event.target.closest('.prd-Media_Slide').getAttribute('data-slide')
    }

    this.showLightbox(slideIndex)

    window.dispatchEvent(new CustomEvent('PDP-gallery-click', {
      detail: {
        mediaIndex: slideIndex,
      },
    }))
  }

  trackThumbnailClick (event) {
    const thumbnail = event.target.closest(this.els.thumbnail.selector)
    if (!thumbnail) return

    const thumbnailIndex = thumbnail.dataset?.thumbnail

    window.dispatchEvent(new CustomEvent('PDP-gallery-thumbnail-click', {
      detail: {
        mediaIndex: thumbnailIndex,
      },
    }))
  }

  showLightbox (index) {
    const lightboxNode = this.renderTemplate()
    document.documentElement.appendChild(lightboxNode)

    const productCount = lightboxNode.querySelectorAll(`.prd-Media_Slide`).length
    const mediaItems = lightboxNode.querySelector('.prd-Media_Slides')
    const lightboxController = new AbortController()
    const signal = lightboxController.signal

    const closeLightbox = () => {
      lightboxNode.parentNode.removeChild(lightboxNode)
      lightboxController.abort()
      document.querySelector('html').classList.remove('modal-open')
    }

    window.addEventListener(
      'keydown',
      ev => {
        if (ev.key === 'Escape') {
          closeLightbox()
        }
      },
      {
        signal,
      },
    )

    lightboxNode
      .querySelector('.prd-MediaZoom_Close')
      .addEventListener('click', () => {
        closeLightbox()
      })

    lightboxNode.addEventListener('click', ev => {
      if (ev.target.closest('.prd-Media_Thumbnails')) return

      closeLightbox()
    })
    document.querySelectorAll('.prd-MediaZoom_Thumbnails [data-thumbnail]').forEach(
      tn => {
        tn.setAttribute('aria-current', false)
      },
    )
    document.querySelector('html').classList.add('modal-open')

    if (index) {
      document.querySelector(`.prd-MediaZoom .prd-Media_Thumbnail[data-thumbnail="${index}"]`).click()
    }
  }

  initialiseCarousel () {
    if (this.els.slide.elements.length > 3) {
      return new window.KeenSlider(
        this.els.slides.element,
        {
          selector: this.els.slide.selector,
          defaultAnimation: {
            duration: 500,
          },
          loop: true,
          mode: 'snap',
          slides: {
            perView: 1,
            spacing: 0,
          },
          initial: 1,
          breakpoints: {
            '(min-width: 990px)': {
              initial: this.els.slide.elements.length - 1,
              vertical: true,
            },
          },
        },
        [
          window.BAO.Carousel.useInitialised(),
          window.BAO.Carousel.useDots(
            this.els.dot.elements,
            (carousel, dot, index) => {
              const amountOfSlides = carousel.slides.length
              const slidesPerView = carousel.options.slides.perView
              const shouldHideSlide =
                index >= amountOfSlides - (slidesPerView - 1)
              dot.setAttribute('aria-hidden', shouldHideSlide.toString())
            },
          ),
          window.BAO.Carousel.useThumbnails(this.els.thumbnail.elements),
          window.BAO.Carousel.useArrows({
            previous: this.els.previous.element,
            next: this.els.next.element,
          }),
        ],
      )
    } else {
      return new window.KeenSlider(
        this.els.slides.element,
        {
          selector: this.els.slide.selector,
          defaultAnimation: {
            duration: 500,
          },
          loop: true,
          mode: 'snap',
          slides: {
            perView: 1,
            spacing: 0,
          },
        },
        [
          window.BAO.Carousel.useInitialised(),
          window.BAO.Carousel.useDots(
            this.els.dot.elements,
            (carousel, dot, index) => {
              const amountOfSlides = carousel.slides.length
              const slidesPerView = carousel.options.slides.perView
              const shouldHideSlide =
                index >= amountOfSlides - (slidesPerView - 1)
              dot.setAttribute('aria-hidden', shouldHideSlide.toString())
            },
          ),
          window.BAO.Carousel.useThumbnails(this.els.thumbnail.elements),
          window.BAO.Carousel.useArrows({
            previous: this.els.previous.element,
            next: this.els.next.element,
          }),
        ],
      )
    }
  }
}

if (!customElements.get('bao-product-media')) {
  customElements.define('bao-product-media', BaoProductMedia)
}
